'use client';

import { usePathname } from 'next/navigation';

import { FiltersForDivisionsPage } from '@/components/organisms/FiltersForSpectatorPages/FiltersForDivisionsPage';
import { FiltersForPlayersPage } from '@/components/organisms/FiltersForSpectatorPages/FiltersForPlayersPage';
import { FiltersForSchedulePage } from '@/components/organisms/FiltersForSpectatorPages/FiltersForSchedulePage';
import { FiltersForStandingsPage } from '@/components/organisms/FiltersForSpectatorPages/FiltersForStandingsPage';
import { FiltersForTeamsPage } from '@/components/organisms/FiltersForSpectatorPages/FiltersForTeamsPage';
import { TeamDashboardFilters } from '@/components/organisms/FiltersForSpectatorPages/TeamDashboardFilters';
import { useSeasonDistrictDivisionInfo } from '@/hooks/custom-hooks/useSeasonDistrictDivisionInfo';
import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';

export const pageRoutes = {
	STANDINGS: '/standings',
	GAMEDAY: '/gameday',
	DIVISIONS: '/divisions',
	TEAMS: '/teams',
	PLAYERS: '/players',
	TEAM_DASHBOARD: '/team-dashboard'
};

export const getLastPathSegment = (path: string) => {
	if (!path) return '';
	const segments = path.split('/').filter((segment) => segment !== '');
	if (segments.length === 0) return '/';
	return '/' + segments[segments.length - 1];
};

export const SpectatorPagesFilterWrapper = () => {
	const pathname = usePathname();
	const teamLeagueInfo = useTeamLeagueInfo();
	const { seasonOptions, districtOptions, divisionOptions } = useSeasonDistrictDivisionInfo();

	const currentRoute = getLastPathSegment(pathname);

	const commonProps = {
		seasons: seasonOptions,
		districts: districtOptions,
		divisions: divisionOptions,
		activeSeason: teamLeagueInfo.seasonUuid
	};

	switch (currentRoute) {
		// STANDINGS PAGE
		case pageRoutes.STANDINGS:
			return <FiltersForStandingsPage {...commonProps} />;

		// SCHEDULE PAGE
		case pageRoutes.GAMEDAY:
			return <FiltersForSchedulePage {...commonProps} />;

		// DIVISIONS PAGE
		case pageRoutes.DIVISIONS:
			return <FiltersForDivisionsPage />;

		// TEAMS PAGE
		case pageRoutes.TEAMS:
			return <FiltersForTeamsPage {...commonProps} />;

		// PLAYERS PAGE
		case pageRoutes.PLAYERS:
			return <FiltersForPlayersPage {...commonProps} />;

		// TEAM DASHBOARD PAGE
		case pageRoutes.TEAM_DASHBOARD:
			return <TeamDashboardFilters {...commonProps} />;

		default:
			return null;
	}
};
